import Modal from "react-bootstrap/Modal";

import logo from "../../assets/img/logo.svg";
import { useRef } from "react";
import useInput from "../../hooks/use-input";

import { useSelector } from "react-redux";

type AddPaperToRepositoryProps = {
  repository_id: string;
  addPaperToRepository: (repoId: string, paperName: string) => void;
  onHide: () => void;
  show: boolean;
};

const AddPaperToRepositoryModal = (props: AddPaperToRepositoryProps) => {
  const { userName } = useSelector((state: any) => state.auth);
  const paperNameInput = useRef<HTMLInputElement>(null);

  const {
    value: paperNameValue,
    valueChangeHandler: paperNameChangeHandler,
    inputBlurHandler: paperNameBlurHandler,
    reset: resetPaperName,
  } = useInput();

  const addPaperToRepositoryFormSubmitHandler = async (
    event: React.FormEvent
  ): Promise<void> => {
    event.preventDefault();

    props.addPaperToRepository(props.repository_id, paperNameValue);

    props.onHide();
    resetPaperName();
  };

  return (
    <Modal
      id="ModalRepos"
      size="lg"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="ModalRepos"
      aria-hidden="true"
      {...props}
    >
      <div className="modal-content">
        <button
          type="button"
          className="close"
          data-dismiss="modal"
          aria-label="Close"
          onClick={props.onHide}
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <div className="modal-body text-center">
          <img alt="base" src={logo} className="mb-4" />
          <h4 className="user-title">
            Logged In as <span className="font-weight-bold">{userName}</span>
          </h4>
          <div className="zone">
            <form onSubmit={addPaperToRepositoryFormSubmitHandler}>
              <div className="form-group">
                <label htmlFor="repositoryName">Paper Name</label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="repositoryName"
                  aria-describedby="userNameHelp"
                  ref={paperNameInput}
                  value={paperNameValue}
                  onChange={paperNameChangeHandler}
                  onBlur={paperNameBlurHandler}
                />
              </div>
              <button type="submit" className="btn btn-primary btn-block">
                Add Paper
              </button>
            </form>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AddPaperToRepositoryModal;
